(() => {
  if (window.NovoFreeShippingProgress) return;

  const THRESHOLD = 4500;
  let lastTotal = null;
  let refreshTimer;
  let observerTimer;

  const formatMoney = (cents) => {
    const currency = window.Shopify?.currency?.active || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency
      }).format(cents / 100);
    } catch (error) {
      return '$' + (cents / 100).toFixed(2);
    }
  };

  const buildBar = (location) => {
    const bar = document.createElement('section');
    bar.className = 'free-shipping-progress';
    bar.dataset.location = location;
    bar.setAttribute('role', 'progressbar');
    bar.setAttribute('aria-label', 'Free shipping progress');
    bar.setAttribute('aria-valuemin', '0');
    bar.setAttribute('aria-valuemax', String(THRESHOLD));
    bar.innerHTML =
      '<div class="free-shipping-progress__topline">' +
        '<span class="free-shipping-progress__label">FREE SHIPPING</span>' +
        '<span class="free-shipping-progress__goal"></span>' +
      '</div>' +
      '<p class="free-shipping-progress__message" aria-live="polite"></p>' +
      '<div class="free-shipping-progress__track" aria-hidden="true">' +
        '<span class="free-shipping-progress__fill"></span>' +
      '</div>' +
      '<div class="free-shipping-progress__meta">' +
        '<span class="free-shipping-progress__subtotal"></span>' +
        '<a class="free-shipping-progress__link" href="/collections">Shop add-ons</a>' +
      '</div>';
    return bar;
  };

  const updateBars = (total) => {
    lastTotal = Math.max(0, Number(total) || 0);
    const remaining = Math.max(0, THRESHOLD - lastTotal);
    const percent = Math.min(100, (lastTotal / THRESHOLD) * 100);

    document.querySelectorAll('.free-shipping-progress').forEach((bar) => {
      const complete = lastTotal >= THRESHOLD;
      const empty = lastTotal === 0;
      bar.classList.toggle('is-complete', complete);
      bar.classList.toggle('is-empty', empty);
      bar.setAttribute('aria-valuenow', String(Math.min(lastTotal, THRESHOLD)));
      bar.setAttribute(
        'aria-valuetext',
        complete ? 'Free shipping unlocked' : formatMoney(remaining) + ' away from free shipping'
      );

      const message = bar.querySelector('.free-shipping-progress__message');
      const fill = bar.querySelector('.free-shipping-progress__fill');
      const goal = bar.querySelector('.free-shipping-progress__goal');
      const subtotal = bar.querySelector('.free-shipping-progress__subtotal');

      if (message) {
        message.textContent = complete
          ? '\u2713 You\u2019ve unlocked FREE shipping!'
          : 'You\u2019re ' + formatMoney(remaining) + ' away from FREE shipping';
      }
      if (fill) fill.style.width = percent + '%';
      if (goal) goal.textContent = formatMoney(THRESHOLD) + ' goal';
      if (subtotal) {
        subtotal.textContent = complete
          ? 'Your order qualifies for free worldwide shipping.'
          : 'Cart subtotal: ' + formatMoney(lastTotal);
      }
    });
  };

  const ensureBars = () => {
    const drawer = document.querySelector('cart-drawer .drawer__inner, #CartDrawer .drawer__inner');
    if (drawer && !drawer.querySelector('.free-shipping-progress[data-location="drawer"]')) {
      const bar = buildBar('drawer');
      const header = drawer.querySelector('.drawer__header');
      if (header) header.insertAdjacentElement('afterend', bar);
      else drawer.prepend(bar);
    }

    const cartPageHeader = document.querySelector('cart-items .page-width > .title-wrapper-with-link');
    if (cartPageHeader && !document.querySelector('.free-shipping-progress[data-location="cart-page"]')) {
      cartPageHeader.insertAdjacentElement('afterend', buildBar('cart-page'));
    }

    if (lastTotal !== null) updateBars(lastTotal);
  };

  const refresh = async () => {
    try {
      const response = await fetch((window.routes?.cart_url || '/cart') + '.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      });
      if (!response.ok) return;
      const cart = await response.json();
      ensureBars();
      updateBars(cart.total_price);
    } catch (error) {
      // Keep the last rendered value if the cart endpoint is temporarily unavailable.
    }
  };

  const scheduleRefresh = (delay = 250) => {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refresh, delay);
  };

  const init = () => {
    ensureBars();
    refresh();

    const observer = new MutationObserver(() => {
      window.clearTimeout(observerTimer);
      observerTimer = window.setTimeout(ensureBars, 60);
    });
    observer.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('change', (event) => {
      if (event.target.matches('input[name="updates[]"], .quantity__input')) {
        scheduleRefresh(350);
        window.setTimeout(refresh, 900);
      }
    });

    document.addEventListener('click', (event) => {
      if (event.target.closest('button[name="add"], .quick-add__submit, cart-remove-button, [data-cart-remove], .quantity__button')) {
        scheduleRefresh(450);
        window.setTimeout(refresh, 1000);
      }
    });

    document.addEventListener('shopify:section:load', () => scheduleRefresh(100));

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        const total = event?.cartData?.total_price;
        ensureBars();
        if (Number.isFinite(total)) updateBars(total);
        else scheduleRefresh(100);
      });
    }

    window.addEventListener('pageshow', refresh);
  };

  window.NovoFreeShippingProgress = { refresh, threshold: THRESHOLD };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
